export class ControllerError extends Error {
    constructor(message, cause) {
        const _message = cause && typeof cause === 'object' && 'message' in cause
            ? `${message}, ${cause.message}`
            : message;
        super(_message, { cause });
        this.cause = cause;
        Object.setPrototypeOf(this, new.target.prototype);
        this.name = this.constructor.name;
    }
}
//# sourceMappingURL=errors.js.map